export default "__VITE_ASSET__DvARDdGG__"